import axios from 'axios';

// 장바구니 조회 (/api/user/cart)
// 쇼핑몰 화면에서 Header·RightSidebar 가 동시에 요청하므로 진행 중인 요청 하나를 함께 쓴다.
// 장바구니는 자주 바뀌므로 응답이 끝나면 공유를 해제한다 (캐시하지 않음).
let cartPromise = null;

export function getCart() {
  if (!cartPromise) {
    const token = localStorage.getItem('auth_token');
    cartPromise = axios.get('/api/user/cart', {
      headers: { 'Authorization': `Bearer ${token}` }
    })
      .then(response => response.data)
      .finally(() => {
        cartPromise = null;
      });
  }
  return cartPromise;
}
